import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeVehicleMutationVariables = Types.Exact<{
  input: Types.MergeVehicleInput;
}>;


export type MergeVehicleMutation = { __typename?: 'Mutation', mergeVehicle: { __typename?: 'VehiclePayload', vehicle?: { __typename?: 'VehicleStateData', tenantId: string, vehicleId: string, name: string, vehicleTypeId: string, carrierId?: string | null, licensePlate: string, ownership: Types.VehicleOwnership, hasLiftgate: boolean, isTempControlled: boolean, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteVehicleMutationVariables = Types.Exact<{
  input: Types.DeleteVehicleInput;
}>;


export type DeleteVehicleMutation = { __typename?: 'Mutation', deleteVehicle: { __typename?: 'VehiclePayload', vehicle?: { __typename?: 'VehicleStateData', tenantId: string, vehicleId: string, name: string, vehicleTypeId: string, carrierId?: string | null, licensePlate: string, ownership: Types.VehicleOwnership, hasLiftgate: boolean, isTempControlled: boolean, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsVehicleStateFieldsFragment = { __typename?: 'VehicleStateData', tenantId: string, vehicleId: string, name: string, vehicleTypeId: string, carrierId?: string | null, licensePlate: string, ownership: Types.VehicleOwnership, hasLiftgate: boolean, isTempControlled: boolean, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsVehicleStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsVehicleStateFields on VehicleStateData {
  tenantId
  vehicleId
  name
  vehicleTypeId
  carrierId
  licensePlate
  ownership
  hasLiftgate
  isTempControlled
  isActive
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsVehicleStateFields"});
export const MergeVehicleDocument = new TypedDocumentString(`
    mutation MergeVehicle($input: MergeVehicleInput!) {
  mergeVehicle(input: $input) {
    vehicle {
      ...LogisticsVehicleStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsVehicleStateFields on VehicleStateData {
  tenantId
  vehicleId
  name
  vehicleTypeId
  carrierId
  licensePlate
  ownership
  hasLiftgate
  isTempControlled
  isActive
  updatedAt
  updatedBy
}`);
export const DeleteVehicleDocument = new TypedDocumentString(`
    mutation DeleteVehicle($input: DeleteVehicleInput!) {
  deleteVehicle(input: $input) {
    vehicle {
      ...LogisticsVehicleStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsVehicleStateFields on VehicleStateData {
  tenantId
  vehicleId
  name
  vehicleTypeId
  carrierId
  licensePlate
  ownership
  hasLiftgate
  isTempControlled
  isActive
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeVehicle: build.mutation<MergeVehicleMutation, MergeVehicleMutationVariables>({
      query: (variables) => ({ document: MergeVehicleDocument, variables })
    }),
    DeleteVehicle: build.mutation<DeleteVehicleMutation, DeleteVehicleMutationVariables>({
      query: (variables) => ({ document: DeleteVehicleDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeVehicleMutation, useDeleteVehicleMutation } = injectedRtkApi;
